"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenProviderInstance = exports.getTokenProviderConfig = void 0;
const fitjava_script_client_1 = require("@amzn/fitjava-script-client");
const CONSTANTS = __importStar(require("../common/constants"));
function getTokenProviderConfig() {
    const baseHref = window.location.hostname;
    let fitClientConfig = CONSTANTS.DEFAULT_FIT_CLIENT_CONFIG;
    CONSTANTS.FIT_CLIENT_CONFIGS.forEach((value, key) => {
        if (baseHref.indexOf(key) != -1) {
            fitClientConfig = value;
        }
    });
    return fitClientConfig;
}
exports.getTokenProviderConfig = getTokenProviderConfig;
exports.tokenProviderInstance = new fitjava_script_client_1.TokenProvider(getTokenProviderConfig());
